<div class="flex gap-8">


  <div *ngIf="chromeUXData?.results?.desktop" class="w-1/2">
    <div class="text-lg font-medium border-gray-300 border-b mb-5">
      Desktop
    </div>
    <div>
      <div *ngIf="chromeUXData.results.desktop['FCP']">
        <app-performance-check
          label="TTFB"
          [value]="chromeUXData.results.desktop['FCP']"
          [style]="getTTFBStyling(chromeUXData.results.desktop['FCP'])"></app-performance-check>
      </div>
      <div *ngIf="chromeUXData.results.desktop['CLS']">
        <app-performance-check
          label="CLS"
          [value]="chromeUXData.results.desktop['CLS']"
          [style]="getCLSStyling(chromeUXData.results.desktop['CLS'])"
        ></app-performance-check>
      </div>
      <div *ngIf="chromeUXData.results.desktop['LCP']">
        <app-performance-check
          label="LCP"
          [value]="chromeUXData.results.desktop['LCP']"
          [style]="getLCPStyling(chromeUXData.results.desktop['LCP'])"
        ></app-performance-check>
      </div>
    </div>
  </div>
  <div *ngIf="chromeUXData?.results?.phone" class="w-1/2">
    <div class="text-lg font-medium border-gray-300 border-b mb-5">
      Phone
    </div>
    <div>
      <div *ngIf="chromeUXData.results.phone['FCP']">
        <app-performance-check
          label="TTFB"
          [value]="chromeUXData.results.phone['FCP']"
          [style]="getTTFBStyling(chromeUXData.results.phone['FCP'])"
        ></app-performance-check>
      </div>
      <div *ngIf="chromeUXData.results.phone['CLS']">
        <app-performance-check
          label="CLS"
          [value]="chromeUXData.results.phone['CLS']"
          [style]="getCLSStyling(chromeUXData.results.phone['CLS'])"
        ></app-performance-check>
      </div>
      <div *ngIf="chromeUXData.results.phone['LCP']">
        <app-performance-check
          label="LCP"
          [value]="chromeUXData.results.phone['LCP']"
          [style]="getLCPStyling(chromeUXData.results.phone['LCP'])"
        ></app-performance-check>

      </div>
    </div>
  </div>
</div>
